<template>
    <div class="main_center">
        <div class="right-content">
            <el-form ref="editForm" :model="form" :rules="formRules" label-width="120px" v-loading="formLoading">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>需求模板维护</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="品目名称：" style="width:100%;">
                                    <el-input v-model="form.purchaseItemName" class="limit-word-input" disabled maxlength="100" show-word-limit ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="品目编号：" style="width:100%;">
                                    <el-input v-model="form.purchaseItemCode" class="limit-word-input" disabled maxlength="100" show-word-limit ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="模板类型：" prop='type' size="small">
                                    <el-radio-group v-model="form.type" :disabled="!globalEdit">
                                        <el-radio :label="'1'">标准模板</el-radio>
                                        <el-radio :label="'2'">自定义模板</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="form.type == '1'">
                                <el-form-item label="标准模板：" prop='standardType' size="small">
                                    <el-select v-model="form.standardType" placeholder="请选择模板" v-if="globalEdit">
                                        <el-option
                                                v-for="item in standardTypeList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{form.standardTypeName}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="form.type == '2'">
                            <el-col :span="24">
                                <el-form-item label="模板维护：">
                                    <div style="border:1px solid #dcdfe6;">
                                        <div class="leftTree" ref="leftTree" v-show="showTree" :style="`width:${treeWidth}px;`">
                                            <el-tree
                                                    :data="treeData"
                                                    node-key="staticId"
                                                    ref="tree"
                                                    empty-text="暂无数据"
                                                    :props="cusProps"
                                                    default-expand-all
                                                    :highlight-current="true"
                                                    @node-click="handleTreeNodeClick"
                                                    @node-drag-start="handleDragStart"
                                                    @node-drag-enter="handleDragEnter"
                                                    @node-drag-leave="handleDragLeave"
                                                    @node-drag-over="handleDragOver"
                                                    @node-drag-end="handleDragEnd"
                                                    @node-drop="handleDrop"
                                                    draggable
                                                    :allow-drop="allowDrop"
                                                    :allow-drag="allowDrag"
                                                    :expand-on-click-node="true"
                                            >
                                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                              <div v-if="node.isLeaf" @mouseover="data.hover = true" @mouseleave="data.hover = false">
                                                <div class="addNodeWrapper" v-if="data.edit">
                                                  <el-input style="width:210px;" v-model="nodeLabel"></el-input>
                                                  <el-button @click.stop="saveAddNode(node,data)" type="text">
                                                    <i class="el-icon-success"></i>
                                                  </el-button>
                                                  <el-button @click.stop="cancelEditNode(node,data)" type="text">
                                                    <i class="el-icon-error"></i>
                                                  </el-button>
                                                </div>
                                                <div v-else>
                                                  <span class="pointer"></span>
                                                  <span>{{ node.label }}</span>
                                                  <span style="margin-left: 4px" v-if="globalEdit && data.hover">
                                                    <el-button title="编辑" @click.stop="editNode(node,data)" class="svg-icon-btn" type="text">
                                                      <icon-svg class="svg-icon" name="edit"></icon-svg>
                                                    </el-button>
                                                    <el-button title="删除" @click.stop="deleteNode(node,data)" class="svg-icon-btn" type="text">
                                                      <icon-svg class="svg-icon" name="delete"></icon-svg>
                                                    </el-button>
                                                  </span>
                                                </div>
                                              </div>
                                              <div v-else>
                                                <span>{{ node.label }}</span>
                                              </div>
                                            </span>
                                            </el-tree>
                                            <div style="padding-left: 24px;margin: 16px auto">
                                                <el-button
                                                        @click="addNode()"
                                                        icon="el-icon-plus"
                                                        plain
                                                        size="mini"
                                                        type="primary"
                                                        v-if="globalEdit"
                                                >新增目录</el-button>
                                                <br />
                                                <div v-if="addNodeFlag" class="addNodeWrapper">
                                                    <el-input style="width:210px;margin-top: 10px" v-model="nodeLabel"></el-input>
                                                    <el-button @click="saveAddNode()" type="text">
                                                        <i class="el-icon-success"></i>
                                                    </el-button>
                                                    <el-button type="text" @click="cancelEditNode()">
                                                        <i class="el-icon-error"></i>
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div @click="isShowTreeBtn('no')" :class="showTree?'isShowtreeBtn':'yinCang'">
                                            <i class="el-icon-arrow-left iconarrow"></i>
                                        </div>
                                        <div @click="isShowTreeBtn('yes')" :class="showTree?'yinCang':'showTree'">
                                            <i class="el-icon-arrow-right iconarrow"></i>
                                        </div>
                                        <div
                                                class="rightTable"
                                                :class="{'openRightTable':addNodeFlag}"
                                                :style="`width: calc(100% - ${treeWidth}px);`"
                                        >
                                            <el-button style="margin-left: 4px" @click="addTableNode()" size="mini" type="default" v-if="globalEdit">
                                                <i class="el-icon-plus"></i>添加模板
                                            </el-button>
                                            <el-table
                                                    :data="form.purchaseItemTemplateDtoList"
                                                    :row-key="getRowKeys"
                                                    border
                                                    :key="tableMathKey"
                                                    ref="multipleTable"
                                                    stripe
                                                    v-loading="dataListLoading"
                                            >
                                                <el-table-column
                                                        fixed
                                                        label="序号"
                                                        type="index"
                                                        :index="indexMethod"
                                                        width="50"
                                                        align="center"
                                                        :show-overflow-tooltip="true"
                                                ></el-table-column>
                                                <el-table-column
                                                        :show-overflow-tooltip="true"
                                                        align="center"
                                                        label="名称"
                                                        prop="name">
                                                    <template slot-scope="scope">
                                                        <template v-if="globalEdit">
                                                            <!--                                                                          :prop="'purchaseItemTemplateDtoList.'+scope.$index+'.name'"-->
                                                            <el-form-item label-width="0px" class="tableInnerForm"
                                                                          :rules="formRules.name">
                                                                <el-input v-model="scope.row.name"></el-input>
                                                            </el-form-item>
                                                        </template>
                                                        <template v-else>
                                                            <span>{{scope.row.name}}</span>
                                                        </template>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        :show-overflow-tooltip="true"
                                                        align="center"
                                                        label="是否显示"
                                                        prop="isShow"
                                                        width="100px">
                                                    <template slot-scope="scope">
                                                        <template v-if="globalEdit">
                                                            <el-form-item label-width="0px" class="tableInnerForm">
                                                                <el-checkbox :disabled="!globalEdit" :true-label="1" :false-label="0" v-model="scope.row.isShow"></el-checkbox>
                                                            </el-form-item>
                                                        </template>
                                                        <template v-else>
                                                            <el-checkbox :disabled="!globalEdit" :true-label="1" :false-label="0" v-model="scope.row.isShow"></el-checkbox>
                                                        </template>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        v-if="globalEdit"
                                                        :show-overflow-tooltip="true"
                                                        align="center"
                                                        label="模板维护"
                                                        prop="filePath"
                                                        width="180px">
                                                    <template slot-scope="scope">
<!--                                                          :prop="'purchaseItemTemplateDtoList.'+scope.$index+'.filePath'" -->
                                                        <el-form-item label-width="0px" class="tableInnerForm"
                                                                      :rules="formRules.filePath">
                                                            <el-button size="mini" icon="el-icon-download" @click="expertTemplate(scope.row)">导出</el-button>
                                                            <el-button size="mini" icon="el-icon-upload2" @click="importTemplate(scope.$index)">导入</el-button>
                                                        </el-form-item>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        :show-overflow-tooltip="true"
                                                        align="center"
                                                        label="模板导入时间"
                                                        width="180px"
                                                        prop="importTime">
                                                    <template slot-scope="scope">
                                                        <template v-if="globalEdit">
                                                            <el-form-item label-width="0px" class="tableInnerForm">
                                                                <span>{{scope.row.importTime}}</span>
                                                            </el-form-item>
                                                        </template>
                                                        <template v-else>
                                                            <span>{{scope.row.importTime}}</span>
                                                        </template>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        :show-overflow-tooltip="true"
                                                        align="center"
                                                        label="操作"
                                                        v-if="globalEdit"
                                                        width="150px"
                                                >
                                                    <template slot-scope="scope">
                                                        <el-button
                                                                @click="sortFn(scope.row.id,3,scope.$index)"
                                                                class="svg-icon-btn"
                                                                type="text"
                                                                :title="'置顶'"
                                                        >
                                                            <icon-svg class="svg-icon" name="ding" ></icon-svg>
                                                        </el-button>
                                                        <el-button
                                                                :disabled="!globalEdit"
                                                                @click="sortFn(scope.row.id,1,scope.$index)"
                                                                class="svg-icon-btn"
                                                                style="margin-left: 4px"
                                                                type="text"
                                                                :title="'上移'"
                                                        >
                                                            <icon-svg class="svg-icon" name="shang" ></icon-svg>
                                                        </el-button>
                                                        <el-button
                                                                :disabled="!globalEdit"
                                                                @click="sortFn(scope.row.id,2,scope.$index)"
                                                                class="svg-icon-btn"
                                                                style="margin-left: 4px"
                                                                type="text"
                                                                :title="'下移'"
                                                        >
                                                            <icon-svg class="svg-icon" name="xia" ></icon-svg>
                                                        </el-button>
                                                        <el-button
                                                                :disabled="!globalEdit"
                                                                @click="deleteTableNode(scope.row,scope.$index)"
                                                                class="svg-icon-btn"
                                                                style="margin-left: 4px"
                                                                type="text"
                                                                :title="'删除'"
                                                        >
                                                            <icon-svg class="svg-icon" name="delete" ></icon-svg>
                                                        </el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div style="clear: both"></div>
                                    </div>

                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small" v-if="globalEdit" type="primary" @click="saveData">保存</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>
        <upload ref="uploadComRef" accept-file-type=".doc,.DOC,.docx,.DOCX" @uploadSuccess="uploadSuccess"></upload>
    </div>
</template>

<script>
    import $ from 'jquery';
    import {mapState} from "vuex";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import {httpMixinsCommonGet, httpMixinsCommonPost, httpSuiteLoadDicts} from "@/server/purchase";
    import {formatSuiteDictOptionsData} from "@/utils";
    import upload from "@/components/affixMsg/upload";
    export default {
        components: {
            upload
        },
        data() {
            return {
                formRules: {
                    type: [{ required: true, message: '请选择模板类型', trigger: 'change' }],
                    standardType: [{ required: true, message: '请选择标准模板', trigger: 'change' }],
                    purchaseItemCatalogDtoList:[{ required: true, message: '请添加自定义模板', trigger: 'change' }],
                    name: [{ required: true, message: '请选择输入目录名称', trigger: 'blur' }],
                    filePath: [{ required: true, message: '请导入模板', trigger: 'change' }],
                },
                nodeLabel: '',
                addNodeFlag: false,
                treeWidth: 274,
                showTree: true,
                dataListLoading:false,
                tableMathKey:Math.random(),
                form: {
                    purchaseItemName:"",
                    purchaseItemCode:"",
                    versionId:"",
                    standardType:"",
                    busTypeName: '',
                    purchaserMode:"", // 采购方式
                    purchaserModeName:"",
                    nodeName: '物业管理服务',//节点名称
                    type:'1',
                    purchaseItemCatalogDtoList:[],
                    purchaseItemTemplateDtoList:[],
                },
                treeData: [
                    {
                        staticId: "1",
                        label: "目录",
                        level: 1,
                        children: []
                    }
                ],
                cusProps: {
                    children: "children",
                    label: "label"
                },
                standardTypeList:[],
                id: '', //点击提交的时候也传id
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total: 0,//总条数,
                globalEdit:false,
                formLoading:false,
                selectRowIndex:-1,

            }
        },
        computed: {
            ...mapState({
                stateData: state => state.user
            }),
        },
        created(){
            httpSuiteLoadDicts('standard_type').then((res) => {
                let data = formatSuiteDictOptionsData(res.data);
                this.standardTypeList = data;
            })
        },
        activated() {
            this.id = this.$route.query.id;
            this.getDataById();
            this.globalEdit = this.$route.query.type && this.$route.query.type == '1'?true:false;

        },
        methods: {
            isShowTreeBtn(flag) {
                if (flag === "no") {
                    this.treeWidth = 0;
                    this.showTree = false;
                } else if (flag === "yes") {
                    this.treeWidth = 274;
                    this.showTree = true;
                }
            },


            resetEdit() {
                this.globalEdit = false;
            },
            cancelEditNode(node, data) {
                if(node){
                    data.edit = false;
                    this.addNodeFlag = false;
                }else{
                    this.addNodeFlag = false;
                }
                this.nodeLabel = '';
            },
            saveAddNode(node, data) {
                if(!this.nodeLabel){
                    this.$message({
                        type: "error",
                        message: '请输入模板目录。'
                    });
                    return
                }
                //保存检查对象
                if (node && data && this.nodeLabel) {
                    data.label = this.nodeLabel;
                    data.edit = false;
                    data.name = this.nodeLabel;
                    this.currentNode = data;

                } else if (this.nodeLabel) {
                      let purchaseItemTemplateDtoList = [];
                      let currentNode = {
                          label:this.nodeLabel,
                          name:this.nodeLabel,
                          hover:false,
                          edit:false,
                          level:2,
                          staticId:Math.random().toString(),
                          purchaseItemId:this.id,
                          type:this.form.type,
                          purchaseItemTemplateDtoList:purchaseItemTemplateDtoList,
                      }
                      this.treeData[0].children.push(currentNode)
                    this.form.purchaseItemTemplateDtoList = purchaseItemTemplateDtoList;
                    this.tableMathKey = Math.random();
                    this.currentNode = currentNode;

                }

                this.nodeLabel = '';
                this.addNodeFlag = false;

                // if (node && data && this.nodeLabel) {
                //   data.label = this.nodeLabel
                //   data.edit = false;
                // }else if(this.nodeLabel){
                //   this.treeData[0].children.push({
                //         label:this.nodeLabel,
                //         hover:false,
                //         edit:false,
                //         level:2,
                //         id:Math.random().toString(),
                //     })
                // }
                // this.addNodeFlag = false;

            },
            addNode(node, data) {

                if(this.addNodeFlag){
                    this.$message({
                        type: "error",
                        message: '请先保存待编辑模板目录。'
                    });
                    return;
                }
                if(this.nodeLabel){
                    this.$message({
                        type: "error",
                        message: '请先完成“'+this.nodeLabel+'”模板目录编辑。'
                    });
                    return;
                }

                this.addNodeFlag = true;
                this.currentNode = {};
                this.nodeLabel = '';
                this.copyParentId = '';
            },
            deleteNode(node, data) {

                this.$confirm(`确定要删除该数据?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {

                    let idx = this.treeData[0].children.findIndex((val) => val.staticId == data.staticId)
                    if(idx > -1){
                        this.treeData[0].children.splice(idx, 1);
                    }


                    // httpMixinsCommonPost("/purchase/itemVersion/delete", {
                    //     id: data.id
                    // })
                    //     .then(res => {
                    //         if (res.data.code == "1") {
                    //             this.$message({
                    //                 type: "success",
                    //                 message: res.data.msg
                    //             });
                    //             this.getTreeData();
                    //         } else {
                    //             this.$message({
                    //                 type: "error",
                    //                 message: res.data.msg
                    //             });
                    //         }
                    //     });
                });
            },
            editNode(node, data) {
                if(this.addNodeFlag){
                    this.$message({
                        type: "error",
                        message: '请先完成新增的保存。'
                    });
                    return
                }
                data.edit = true;
                this.nodeLabel = data.name;
                this.copyParentId = '';
                this.form.purchaseItemTemplateDtoList = data.purchaseItemTemplateDtoList;
                this.tableMathKey = Math.random();
            },
            handleDragStart(node, ev) {
                // console.log('drag start', node);
            },
            handleDragEnter(draggingNode, dropNode, ev) {
                // console.log('tree drag enter: ', dropNode);
            },
            handleDragLeave(draggingNode, dropNode, ev) {
                // console.log('tree drag leave: ', dropNode.label);
            },
            handleDragOver(draggingNode, dropNode, ev) {
                // console.log('tree drag over: ', dropNode.label);
            },
            handleDragEnd(draggingNode, dropNode, dropType, ev) {
                // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
                // console.log('tree drop: ', dropNode.label, dropType);
            },
            allowDrop(draggingNode, dropNode, type) {
                //拖拽时判定目标节点能否被放置
                if (!dropNode.isLeaf) {
                    return false;
                }
                if (type == "next" || type == "prev") {
                    return true;
                } else {
                    return false;
                }
            },
            allowDrag(draggingNode) {
                //树节点等级判断是否可拖拽
                // return false;
                if (draggingNode.level == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            handleTreeNodeClick(data) {
                if (data.level == 2) {
                    this.currentNode = data;
                    this.form.purchaseItemTemplateDtoList = data.purchaseItemTemplateDtoList || [];
                    this.tableMathKey = Math.random();
                }
            },
            uploadBtn(index) {
                this.selectRowIndex = index;
                this.$refs.uploadComRef.selectFileClick();
            },
            uploadSuccess(res){
                this.form.purchaseItemTemplateDtoList[this.selectRowIndex].filePath = res.filepath;
                this.form.purchaseItemTemplateDtoList[this.selectRowIndex].importTime = this.formatDate(new Date(),'yyyy-MM-dd HH:mm:ss');
                this.formLoading = false;
                this.$confirm(`上传成功，请记得保存数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                })
            },
            expertTemplate(row){
                if(row.filePath){
                    var a = document.createElement('a');
                    a.download = row.filePath;
                    a.target = "_Blank";
                    a.href = row.filePath;
                    $("body").append(a);
                    a.click();
                    $(a).remove();
                }else{
                    this.$message.error('未找到模板文件路径。')
                }
            },
            importTemplate(rowIndex){
                this.$confirm("将以覆盖的方式导入章节模版，是否确定?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                })
                    .then(() => {
                        this.uploadBtn(rowIndex)
                    })
                    .catch(() => {
                    });
            },
            getRowKeys(row) {
                return row.staticId || row.id;
            },
            indexMethod(index) {
                return index + 1;
            },
            deleteTableNode(row, index) {
                this.$confirm("确认要删除该数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                })
                    .then(() => {
                        this.form.purchaseItemTemplateDtoList.splice(index, 1);
                    })
                    .catch(() => {
                        // this.$message({
                        //     type: 'info',
                        //     message: '已取消删除'
                        // });
                    });
            },
            sortFn(id, type, index) {
                // 1 上 2下 3置顶
                if ((type == 1 || type == 3) && index == 0) {
                    this.$message.error("已到顶部，不可上移。");
                    return;
                }
                if (type == 2 && index == this.form.purchaseItemTemplateDtoList.length - 1) {
                    this.$message.error("已到底部，不可下移。");
                    return;
                }
                var splice = this.form.purchaseItemTemplateDtoList.splice(index, 1);
                if (type == 3) {
                    this.form.purchaseItemTemplateDtoList.unshift(splice[0]);
                }
                if (type == 1) {
                    this.form.purchaseItemTemplateDtoList.splice(index - 1, 0, splice[0]);
                }
                if (type == 2) {
                    this.form.purchaseItemTemplateDtoList.splice(index + 1, 0, splice[0]);
                }

            },
            saveData(){

                let leftTreeDAta = this.treeData[0].children ;
                this.form.purchaseItemCatalogDtoList = leftTreeDAta;
                this.form.purchaseItemCatalogDtoList.forEach((item,index)=>{
                    item.sort = index + 1;
                    if(item.purchaseItemTemplateDtoList && item.purchaseItemTemplateDtoList.length > 0){
                        item.purchaseItemTemplateDtoList.forEach((itm,idx)=>{
                            itm.sort = idx + 1;
                        })
                    }
                })
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.formLoading = true;
                        httpMixinsCommonPost("/purchase/itemTemplate/save", this.form)
                            .then(res => {
                                this.formLoading = false;
                                if (res.data.code == "1") {
                                    this.getDataById();
                                    this.$message({
                                        type: "success",
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.data.msg
                                    });
                                }
                            });
                    }else{
                        this.scrollToErrorItem(this.$refs['editForm']);

                    }
                });

            },
            scrollToErrorItem(elDom) {
                var errorElDom = elDom.fields.filter((item) => {
                    return item.validateState === 'error';
                });
                if(errorElDom.length){
                    errorElDom[0].$el.scrollIntoView({ block: 'center', behavior: 'smooth' })
                }
            },
            backBtn() { //返回
                tabsCloseCurrentHandle();
                this.$router.push({
                    name: 'purchaseCatalogueConfig'
                })
                this.$refs.form.resetFields();
            },
            addTableNode(type) {
                if(this.currentNode.staticId && this.currentNode.staticId != '1'){
                    //添加表格数据
                    let tableItem = {
                        staticIdd:Math.random(),
                        name: "",
                        remark:'',
                        type:this.form.type,
                        importTime:'',
                        filePath:'',
                        isShow: true,
                        editRow: true,
                        purchaseItemId:this.id
                    };
                    this.form.purchaseItemTemplateDtoList.push(tableItem);
                    this.tableMathKey = Math.random();
                }else{
                    this.$message.error('请先选择模板目录。')
                }

            },
            getDataById() { //详情
                if (this.id != "") {
                    httpMixinsCommonGet(`/purchase/item/get/${this.id}`).then((res)=>{
                        if(res.data.code == '1'){
                           let resData = res.data.data;
                            this.form = {...resData};
                        }else{
                            this.$message.error(res.data.msg)
                        }
                    })
                    httpMixinsCommonGet(`/purchase/itemCatalog/getListByItemId/${this.id}`).then((res)=>{
                        if(res.status == 200){
                            let resData = res.data;
                            let treeData = resData.map(item => {
                                return {
                                    ...item,
                                    label:item.name,
                                    staticId:item.id,
                                    disabledUpload: false,
                                    hover:false,
                                    level:2,
                                    edit:false,
                                }
                            });
                            this.treeData[0].children = treeData;
                        }else{
                            this.treeData[0].children = [];
                            this.$message.error(res.data.msg)
                        }
                    })


                }
            },
        }


    }
</script>

<style lang="less" scoped>
    .tableInnerForm{
        margin-bottom: 16px !important;
    }
    .leftTree {
        // width: 274px;
        float: left;
        padding: 10px 0px 24px 0px;
        border-right:1px solid #dcdfe6;
        ::v-deep .el-button + .el-button {
            margin-left: 4px;
        }

        ::v-deep .is-leaf.el-tree-node__expand-icon {
            display: none;
        }

        .addNodeWrapper {
            .el-range-editor.el-input__inner {
                padding: 3px 0px 3px 8px;
            }
        }

        .pointer {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin: 2px 6px;
            background: rgba(0, 0, 0, 0.25);
        }

        .iconImg {
            width: 14px;
        }

        ::v-deep .el-tree-node__content {
            height: 36px;
            ::v-deep .el-icon-folder {
                padding: 0;
                display: none;
            }
        }

        .el-tree--highlight-current {
            ::v-deep .el-tree-node.is-current {
                > .el-tree-node__content {
                    background-color: rgba(27, 154, 238, 0.1);
                    color: rgba(27, 154, 238, 1);
                }
                .pointer {
                    background-color: rgba(27, 154, 238, 1);
                }
            }
        }

        .custom-tree-node {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width:100%;
        }

        ::v-deep span.is-leaf {
            padding: 0 !important;
        }
        .el-input {
            width: 150px !important;
        }
    }
    .rightTable {
        // width: calc(100% - 274px);
        float: right;
        padding:16px;
        .svg-icon-btn {
            margin-left: 4px;
            &:hover {
                color: #1890ff;
            }
        }
        .switch-text {
            font-size: 12px;
            position: absolute;
            color: rgba(255, 255, 255, 1);
            line-height: 24px;
            cursor: pointer;
        }
        .switch-active {
            left: 7px;
        }
        .switch-inactive {
            right: 7px;
        }

        ::v-deep .input-slot-box {
            position: relative;
            display: inline-block;
            .el-input__inner {
                border-radius: 0px;
            }
            .el-input--suffix {
                .el-input__inner {
                    padding: 0 4px;
                    padding-right: 12px;
                    border-left: none;
                }
            }

            .el-input-number__increase {
                top: 2px;
                line-height: 16px;
            }

            .el-input-number__decrease {
                bottom: 3px;
                line-height: 16px;
            }

            .el-input-icon {
                display: inline-block;
                height: 40px;
                text-align: center;
                line-height: 32px;
                background-color: rgba(245, 247, 250, 1);
                color: rgba(0, 0, 0, 0.85);
                border: 1px solid rgba(220, 223, 230, 1);
                position: absolute;
                top: 0px;
                border-radius: 0 4px 4px 0;
            }

            .el-input-icon.el-input-icon-ie {
                top: 0px;
            }

            .el-input-slot {
                width: 60px;
                right: 0px;
                border-radius: 0 4px 4px 0;
                border-left: none;
                border: none;
            }

            .el-input-slot-pre {
                width: 40px;
                position: absolute;
                left: 0px;
                border-radius: 4px 0 0 4px;
                border-right: none;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    .isShowtreeBtn {
        width: 22px;
        height: 80px;
        line-height: 80px;
        text-align: right;
        background-repeat: no-repeat;
        background-size: 100%;
        cursor: pointer;
        background-image: url(../../../../assets/img/close.png);

        position: absolute;
        left: 252px;
        top: 20%;
    }
    .yinCang {
        display: none;
    }
    .iconarrow {
        font-size: 16px;
    }
    .showTree {
        width: 22px;
        height: 80px;
        line-height: 80px;
        text-align: left;
        background-repeat: no-repeat;
        background-size: 100%;
        cursor: pointer;
        background-image: url(../../../../assets/img/open.png);
        position: absolute;
        left: 0px;
        top: 20%;
    }
    .isShowtreeBtn:hover {
        color: #1890ff;
    }
    .showTree:hover {
        color: #1890ff;
    }
    .openRightTable {
        width: calc(100% - 274px);
    }
</style>